import { fetch, resolvePageDataPath } from '@/utils';
import HeadSeo from '@/components/_App/HeadSeo';

import {
  BE_SEARCH_PART_PATH,
  BE_SEARCH_AFTER_MARKET_PARTS_PATH,
} from '@/constant/Paths';
import { PartInnerPageInterface } from '@/types/pages';
import PartInner from '@/components/PartInner';
import ReviewsSection from '@/components/ReviewsSection';

export default function PartInnerPage({
  part,
  partData,
  afterMarketParts,
}: PartInnerPageInterface) {
  return (
    <div>
      <HeadSeo
        title={partData.metaTitle.replace(
          '{partName}',
          part?.title ?? part.partNumber,
        )}
        description={partData.metaDescription.replace(
          '{partName}',
          part?.title ?? part.partNumber,
        )}
      />
      <PartInner
        afterMarketParts={afterMarketParts}
        pageData={partData}
        {...part}
      />
      <ReviewsSection bgColor="bg-black" textColor="text-white" />
    </div>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params: { id, origin },
}: {
  params: { id: string; origin: string };
}) {
  if (!id) {
    return { notFound: true };
  }

  const [partData, layoutData, res, afterMarketRes] = await Promise.all([
    await resolvePageDataPath('partData', origin),
    await resolvePageDataPath('layout', origin),
    await fetch(
      `${BE_SEARCH_PART_PATH}${id}`,
      {
        headers: { accept: 'application/json' },
      },
      origin,
    ),
    await fetch(
      `${BE_SEARCH_AFTER_MARKET_PARTS_PATH}${id}`,
      {
        headers: { accept: 'application/json' },
      },
      origin,
    ),
  ]);

  if (!res.ok) {
    return {
      notFound: true,
    };
  }

  let afterMarketParts = [];
  if (afterMarketRes.ok) {
    afterMarketParts = await afterMarketRes.json();
  }

  const part = await res.json();

  return {
    revalidate: 3600 * 24 * 30, // set revalidate interval of 30 days
    props: {
      part,
      layoutData,
      partData,
      afterMarketParts,
    },
  };
}
